import { render, staticRenderFns } from "./CNPJ.vue?vue&type=template&id=7849c490"
import script from "./CNPJ.vue?vue&type=script&lang=js"
export * from "./CNPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports